import dayjs from "@/utiles/dayjs";
export default {
  name: "conversation",
  components: {},
  props: ["data"],
  data() {
    return {
      modal: false
    };
  },
  computed: {},
  mounted() {},
  methods: {
    openModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    }
  },
  filters: {
    fromNowDate(date) {
      return dayjs(date).format("H:m - YYYY/MM/DD");
    }
  }
};
